import { ESourceTypes } from 'entities/Source';
import { i18n } from 'i18n';

export const SOURCE_TYPES = () => ({
	[ESourceTypes.WEBSITE]: i18n.t('Веб-сайт'),
	[ESourceTypes.BLOGGER]: i18n.t('Блогер'),
	[ESourceTypes.ARBITRATION]: i18n.t('Медиабаинг/Арбитраж'),
});
